export default "__VITE_ASSET__BkgpZ23q__"